import { __ } from '@wordpress/i18n';
import { InspectorControls, store as blockEditorStore } from '@wordpress/block-editor';
import { useSelect, useDispatch } from '@wordpress/data';
import {
    PanelBody,
    SelectControl,
    TextControl,
    NumberInput,
    RangeControl,
    TabPanel,
    Tip,
    Button,
} from '@wordpress/components';

const Inspector = ( { attributes, setAttributes } ) => {
    const {
        postsPerPage,
        orderBy,
    } = attributes;

    const orderByList = [
        { value: 'popular', label: __( 'Popularity', 'realpress' ) },
        { value: 'latest', label: __( 'Latest', 'realpress' ) },
        { value: 'price', label: __( 'Price: low to high', 'realpress' ) },
        { value: 'price-to-low', label: __( 'Price: high to low', 'realpress' ) },
    ];

    return (
        <>
            <InspectorControls>
                <PanelBody title={ __( 'Settings', 'gridflow' ) } initialOpen={ true }>
                    <TextControl label="Post per page"
                                 type="number"
                                 value={parseInt(postsPerPage)}
                                 min={1}
                                 onChange={ ( value ) => setAttributes( { postsPerPage: parseInt(value) } ) }
                    />
                    <SelectControl
                        label={ __( 'Order by', 'realpress' ) }
                        value={ orderBy }
                        options={ orderByList }
                        onChange={ ( value ) => setAttributes( { orderBy: value } ) } />
                </PanelBody>
            </InspectorControls>
        </>
    );
};

export default Inspector;
